import styled from 'styled-components';


type RootProps = {
	fontSize?: number;
	color?: string;
}

type FractionProps = {
	fontSize?: number;
}

type PrefixRootProps = {
	isExpense: boolean;
}

type IntegerProps = {
	fontWeight: number | string;
}

type SymbolProps = {
	fontWeight: number | string;
}

const Root = styled.span<RootProps>`
	position: relative;
	display: inline-flex;
	flex-flow: row nowrap;
	align-items: center;
	white-space: nowrap;
	font-size: ${({ fontSize }) => fontSize ? `${fontSize}px` : 'inherit'};
	color: ${({ color }) => color ? color : 'inherit'};
`;

const Integer = styled.span<IntegerProps>`
	display: inline-block;
	font-weight: ${({ fontWeight }) => fontWeight || 400};
`;

const Fraction = styled.span<FractionProps>`
	position: relative;
	display: inline-block;
	font-size: ${({ fontSize }) => fontSize
		? `${(fontSize / 1.3).toFixed(0)}px`
		: 'inherit'};
	color: #8c8c8c;
`;

const Symbol = styled.span<SymbolProps>`
	display: inline-block;
	font-weight: ${({ fontWeight }) => fontWeight || 400};
`;

const PrefixRoot = styled.span<PrefixRootProps>`
	font-size: 1.28rem;
	vertical-align: middle;
	color: ${({ isExpense }) => isExpense ? '#ff3a48' : '#00c853'};
`;

export {
	Root,
	Integer,
	Fraction,
	Symbol,
	PrefixRoot,
}
